export const logo = (isHomepage, isTouchDevice) => {

    var miniLogo = document.getElementsByClassName('js-mini-logo')[0];

    const init = () => {
  
        bind();
  
    };
  
    const bind = () => {
  
        function removeCurtain() {
            // document.body.classList.add('has-logo-shown');
            document.body.classList.remove('has-curtain-shown');
        }

        function showLogo() {
            document.body.classList.add('has-logo-shown');
        }

        function hideLogo() {
            if (!hideLogo.didrun){ 
                setTimeout(() => {
                    removeCurtain();
                }, 250);
                hideLogo.didrun = true;
            }
            document.body.classList.remove('has-logo-shown');
        }

        setTimeout(() => {
            hideLogo();
        }, 2000);


        miniLogo.addEventListener('mouseenter', e => {
            showLogo();
        });
          
        miniLogo.addEventListener('mouseleave', e => {
            hideLogo();
        });

        ;(function() {
            var throttle = function(type, name, obj) {
                var obj = obj || window;
                var running = false;
                var func = function() {
                    if (running) { return; }
                    running = true;
                    requestAnimationFrame(function() {
                        obj.dispatchEvent(new CustomEvent(name));
                        running = false;
                    });
                };
                obj.addEventListener(type, func);
            };
            throttle ("scroll", "optimizedScroll");
        })();

        window.addEventListener("optimizedScroll", function() {  
            if(window.pageYOffset > 100 ) {
                hideLogo();
            }
        });  

    };
  
   
    init();
    
  
};
  